import get from "lodash/get";
import { array, object, string } from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";
import WideStoryCard from "../../molecules/WideStoryCard";
import LeftImageRightNews from "../../molecules/LeftImageRightNews";
import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import ComponentContainer from "../../layouts/component-container";
import Anchor from "../../atoms/Anchor";
import NewsHeadline from "../../atoms/NewsHeadline";

import { componentProps, getCollectionName, getSlotId, getSlug } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./fourCollection12Stories1Ad.m.css";

const FourCollection12Stories1Ad = ({ collection, sections, publisherAttributes, domainSlug }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const [mostCommentedStories, setMostCommentedStories] = useState([]);
  const { mobile, tab } = useDevice();

  const {
    items,
    adSlot,
    numberOfCollectionsToShow = 4,
    storiesToLoad = 5,
    widgetUrl,
    mostCommentedTitle,
    mostCommentedPosition = 3,
    layoutName,
  } = componentProps(collection);

  const storiesToLoadInFirstCollection = 6;

  const subCollections = items
    .filter(({ type, items }) => type === "collection" && items && items.length)
    .slice(0, numberOfCollectionsToShow);

  if (!(subCollections && subCollections.length)) return null;

  const columnCollections = subCollections.slice(1, 4);
  const [fourthCollection] = subCollections;
  const storyList =
    fourthCollection && fourthCollection.items && fourthCollection.items.length > 0
      ? fourthCollection.items.filter((item) => item.type === "story").slice(0, storiesToLoadInFirstCollection)
      : null;

  const {
    showCollectionName: showSubCollectionName,
    navigateTo: fourthCollectionNavigateTo = "",
    navigateToTitle: fourthCollectionNavigateToTitle,
  } = componentProps(fourthCollection);

  const fourthCollectionName = getCollectionName(fourthCollection, fourthCollectionNavigateToTitle);
  const fourthCollectionSlug = getSlug(fourthCollection, sections, domainSlug, fourthCollectionNavigateTo);

  const mostCommentedData = get(mostCommentedStories, ["pages", "data"], null);
  const mostCommentedStoriesList =
    (mostCommentedData &&
      mostCommentedData.length > 0 &&
      mostCommentedData.filter((item) => item.attributes.comments_count > 0)) ||
    [];

  const mostCommentedStoryObjects =
    (mostCommentedStoriesList &&
      mostCommentedStoriesList.length > 0 &&
      mostCommentedStoriesList
        .map((item) => ({
          story: {
            headline: item.attributes.headline,
            "hero-image-s3-key": item.attributes.hero_image_url,
            url: item.attributes.url,
          },
        }))
        .filter(({ story }) => story.headline && story.headline)) ||
    [];

  if (!storyList) {
    return null;
  }

  useEffect(() => {
    if (mostCommentedPosition) {
      const getMostCommentedStories = async () => {
        const result = await fetch(
          `${publisherAttributes.metypeConfig && publisherAttributes.metypeConfig.metypeHost}/api/v1/accounts/${
            publisherAttributes.metypeConfig && publisherAttributes.metypeConfig.metypeAccountId
          }/all_pages?time_unit=day&time_unit_magnitude=${
            publisherAttributes.metypeConfig && publisherAttributes.metypeConfig.most_commented_magnitude
          }&sort_by=comments_count&per_page=6&domains=${window.location.origin}`
        );
        setMostCommentedStories(await result.json());
      };

      getMostCommentedStories();
    }
  }, []);

  const getStories = (initialSliceCount, endSliceCount) => {
    if (
      mostCommentedPosition === 1 &&
      mostCommentedStoryObjects &&
      mostCommentedStoryObjects.length > initialSliceCount
    ) {
      return mostCommentedStoryObjects.slice(initialSliceCount, endSliceCount);
    } else if (mostCommentedStoryObjects !== 1 && storyList.length > initialSliceCount) {
      return storyList.slice(initialSliceCount, endSliceCount);
    } else return null;
  };

  const [[firstStory], mediumStory, smallStory] = [getStories(0, 1), getStories(1, 3), getStories(3, 6)];

  return (
    <ComponentContainer styleName="base" collection={collection}>
      <div styleName={columnCollections.length > 0 ? "collection-container" : ""}>
        {columnCollections && columnCollections.length > 0 && (
          <Organism1
            subCollections={columnCollections}
            lang={publisherAttributes.lang}
            mostCommentedStoriesList={mostCommentedStoryObjects}
            mostCommentedTitle={mostCommentedTitle}
            mostCommentedPosition={mostCommentedPosition}
            storiesToLoadInRemainingCollections={storiesToLoad}
            adSlot={adSlot}
            layoutName={layoutName}
            collectionSlug={collection.slug}
          />
        )}
        <div className="collection-wrapper">
          {showSubCollectionName && (
            <Anchor
              aria-label={mostCommentedPosition !== 1 ? fourthCollectionName : mostCommentedTitle}
              href={fourthCollectionSlug}
            >
              <h2 styleName="first-collection-name">
                {mostCommentedPosition !== 1 ? fourthCollectionName : mostCommentedTitle}
              </h2>
            </Anchor>
          )}
          <div styleName="collection-story-wrapper">
            <div styleName="middle-column">
              {firstStory && firstStory.story && (
                <WideStoryCard
                  story={firstStory.story}
                  cssStyleName="semiBigSize"
                  aspectRatio={[3, 2]}
                  imageType="image3x2"
                  excerptShow={false}
                  widths={[380, 550, 680]}
                />
              )}
              {mediumStory && (
                <div styleName="medium-story" className="medium-story-cards">
                  <Organism2 storyList={mediumStory} />
                </div>
              )}
            </div>
            <div styleName="right-column">
              {tab ? null : (
                <DfpContainer>
                  <div styleName="ad-slot-300x250" className="adsBox">
                    <DfpComponent
                      type={adSlot}
                      collectionSlug={collection.slug}
                      slotId={getSlotId(adSlot, collection.slug, "four-collection-12-stories")}
                      layoutName={layoutName}
                    />
                  </div>
                </DfpContainer>
              )}
              {smallStory && (
                <div
                  styleName={`${tab ? "tab-small-story" : "small-story"} ${widgetUrl ? "border-bottom" : ""}`}
                  className="small-story-cards"
                >
                  {smallStory.map(({ story }, index) => {
                    return widgetUrl && !mobile ? (
                      <NewsHeadline key={index} story={story} linkEnable={true} className="only-headline" />
                    ) : (
                      <LeftImageRightNews key={index} story={story} widths={[160, 220, 180]} />
                    );
                  })}
                </div>
              )}

              {widgetUrl && (
                <div styleName="widget-available">
                  <iframe title="row 2 iframe title" src={widgetUrl} styleName="widget-iframe"></iframe>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ComponentContainer>
  );
};

FourCollection12Stories1Ad.propTypes = {
  collection: object,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
};

FourCollection12Stories1Ad.nestedCollectionLimit = [6, 5, 5, 5];

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(FourCollection12Stories1Ad);
